<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="19"
    viewBox="0 0 21 19"
    fill="none"
  >
    <path
      d="M6.40836 12.8185C6.13081 12.5297 5.64479 12.4938 5.32756 12.7347L5.31923 12.7293L4.60131 13.4472C4.4439 13.6041 4.35759 13.8135 4.35759 14.0362C4.34812 14.4845 4.74288 14.8784 5.19075 14.8693C5.45148 14.8735 5.68368 14.7432 5.85374 14.5515L6.40836 13.9969C6.52458 13.8807 6.60255 13.736 6.63492 13.5786C6.69303 13.3064 6.60711 13.0144 6.40836 12.8185Z"
      fill="currentColor"
    />
    <path
      d="M4.41179 10.3779C4.08681 10.0529 3.55877 10.0532 3.2334 10.3779C3.15778 10.4539 2.69153 10.9199 2.60522 11.0066C1.85577 11.8199 2.96933 12.9339 3.78312 12.185C3.78312 12.185 4.32832 11.6397 4.41179 11.5563C4.73696 11.2317 4.73696 10.703 4.41179 10.3779Z"
      fill="currentColor"
    />
    <path
      d="M8.1127 14.7188C7.89007 14.7188 7.68067 14.8056 7.52326 14.963L6.89459 15.5916C6.89165 15.5946 6.88871 15.5975 6.88577 15.601C6.57075 15.9122 6.57545 16.4633 6.89459 16.77C7.21972 17.0947 7.74835 17.0947 8.07298 16.77L8.70214 16.1409C9.22322 15.6211 8.84866 14.716 8.1127 14.7188Z"
      fill="currentColor"
    />
    <path
      d="M13.7035 5.47076C12.4173 6.28184 10.6926 6.12787 9.57306 5.00833L8.11565 3.5514L9.93447 1.73258C7.98094 -0.459664 4.54583 -0.598736 2.46641 1.4948C0.375726 3.57127 0.509747 7.00231 2.69738 8.95643C4.29053 8.066 6.24965 9.3097 6.12073 11.1239C7.17564 11.2379 8.06872 12.1941 8.11707 13.2492C9.10906 13.228 10.0944 13.9709 10.336 14.9508C11.1619 14.7295 12.0875 15.0037 12.6531 15.658L12.6698 15.6384C13.4897 16.1307 14.3572 15.1195 13.7388 14.383L13.7403 14.381C13.7275 14.3688 10.4287 11.07 10.4287 11.07C10.6879 10.8108 11.2097 10.289 11.4688 10.0299L14.7426 13.3037C15.5559 14.053 16.6701 12.9387 15.9205 12.1253L12.6472 8.85149C12.9064 8.59227 13.4281 8.07056 13.6873 7.81139C14.4231 8.54711 16.2081 10.3322 16.9611 11.0852C17.2711 11.4081 17.8294 11.408 18.1395 11.0852C18.4641 10.7601 18.4641 10.2314 18.1395 9.90679L13.7035 5.47076Z"
      fill="currentColor"
    />
    <path
      d="M19.4836 1.49468C17.4902 -0.498227 14.2468 -0.498227 12.2534 1.49468C11.8658 1.88252 10.5633 3.18532 10.1973 3.55134L10.6141 3.96816C11.3389 4.69294 12.5177 4.69294 13.242 3.96816L13.7623 3.44787C14.039 3.72753 19.1168 8.79669 19.2595 8.94945C21.4419 6.9946 21.5712 3.56845 19.4836 1.49468Z"
      fill="currentColor"
    />
    <path
      d="M11.5125 16.5901C11.1873 16.2654 10.6591 16.265 10.3341 16.5901L9.70546 17.2188C9.38196 17.5289 9.38211 18.087 9.70546 18.3971C10.016 18.7199 10.5735 18.7197 10.8838 18.3971L11.5125 17.7685C11.8353 17.4588 11.8353 16.8991 11.5125 16.5901Z"
      fill="currentColor"
    />
  </svg>
</template>